import React, { useState } from "react";
import { api } from "../services/api";
import "../style.css";

export default function CategoryForm({ existing, onDone }) {
  const [name, setName] = useState(existing?.name || "");
  const [slug, setSlug] = useState(existing?.slug || "");
  const [description, setDescription] = useState(existing?.description || "");
  const [isActive, setIsActive] = useState(existing?.isActive ?? true);

  const [bannerImage, setBannerImage] = useState(null);
  const [err, setErr] = useState("");

  async function submit(e) {
    e.preventDefault();
    setErr("");

    const form = new FormData();
    form.append("name", name);
    form.append("slug", slug || name);
    form.append("description", description);
    form.append("isActive", String(isActive));
    if (bannerImage) form.append("bannerImage", bannerImage);

    try {
      if (existing?._id) {
        await api.put(`/categories/${existing._id}`, form, { headers: { "Content-Type": "multipart/form-data" } });
      } else {
        await api.post(`/categories`, form, { headers: { "Content-Type": "multipart/form-data" } });
      }
      onDone();
    } catch (ex) {
      setErr(ex?.response?.data?.message || "Save failed");
    }
  }

  return (
    <form onSubmit={submit} className="grid">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h2 style={{ margin: 0 }}>{existing ? "Edit Category" : "New Category"}</h2>
        <button type="button" className="btn btn-ghost" onClick={onDone}>Close</button>
      </div>

      <div className="row">
        <div className="field">
          <label>Name</label>
          <input value={name} onChange={(e) => setName(e.target.value)} />
        </div>

        <div className="field">
          <label>Slug</label>
          <input value={slug} onChange={(e) => setSlug(e.target.value)} placeholder="auto-from-name" />
        </div>
      </div>

      <div className="field">
        <label>Description</label>
        <textarea rows="3" value={description} onChange={(e) => setDescription(e.target.value)} />
      </div>

      <div className="row">
        {/* <div className="field">
          <label>Banner Image (optional)</label>
          <input type="file" accept="image/*" onChange={(e) => setBannerImage(e.target.files?.[0] || null)} />
        </div> */}

        <div className="field">
          <label>Status</label>
          <select value={String(isActive)} onChange={(e) => setIsActive(e.target.value === "true")}>
            <option value="true">Active</option>
            <option value="false">Inactive</option>
          </select>
        </div>
      </div>

      {err ? <div style={{ color: "#dc2626", fontWeight: 900 }}>{err}</div> : null}
      <button className="btn btn-primary">{existing ? "Update Category" : "Create Category"}</button>
    </form>
  );
}
